








import Vue from 'vue';

export default Vue.extend({
  name: 'JerseyQuestion',
  props: { text: String },
  mounted() {},
});
